import { Component } from '@angular/core';
import { StatusSummary } from '../_shared/services/status-page.service';

@Component({
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss'],
    standalone: false
})
export class MaintenanceComponent {
    public type: string;
    constructor() {
        const state: StatusSummary = history.state;
        this.type = state?.status?.toUpperCase() || 'UNDER_MAINTENANCE';
    }
}
